import { Component, OnInit, Input, Output, EventEmitter, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { FiltersPopUpTagsEnum } from '../enums/common.enum';

@Component({
  selector: 'cygov-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
  standalone: false,
})
export class SelectComponent implements OnInit, OnChanges {
  @ViewChild('selectTag', { static: false }) selectInput;
  @Input() items: any;
  @Input() placeholder: string;
  @Input() ngModelValue: any;
  @Input() multiple: boolean;
  @Input() isImageControl: boolean;
  @Input() bindLabel: string;
  @Input() bindValue: any;
  @Input() compareWith: any;
  @Input() groupBy: string;
  @Input() isTextRequired = false;
  @Input() clearable = true;
  @Input() standardSelect = true;
  @Input() searchable = true;
  @Input() disabled = false;
  @Input() customTemplate = false;
  @Input() highlightLabel = false;
  @Input() labelKeys: string[] = [];
  @Input() optionKeys: string[] = [];
  @Input() searchFn = null;
  @Input() replacePipe = false;
  @Input() replaceSearchValue = '';
  @Input() replaceValue = '';
  @Input() customArrow = false;
  @Input() hideArrow = false;
  @Input() appendTo = '';
  @Input() showCheckBox: boolean = false;
  @Input() sortByAlphabet: boolean = false;
  @Input() sortByField: string = ''; // field in the object by which you wanna sort
  @Input() singleSelection: boolean = false;
  @Input() triggerOnSameOption: boolean = false;
  @Input() position: 'top' | 'bottom' | 'auto' = 'auto';
  @Input() largeArrow: boolean = false;
  @Input() fromRiskRegister: boolean = false;
  @Input() showSearchInOptPanel: boolean = false;

  @Output() ngModelValueChange = new EventEmitter<any>();
  @Output() selectOpened = new EventEmitter<any>();
  @Output() selectClosed = new EventEmitter<any>();
  @Output() sameOptionSelected = new EventEmitter<any>();
  // fires when the options panel is scrolled to its end, so a caller can page in the next batch
  @Output() scrolledToEnd = new EventEmitter<void>();

  isDropDownOpen = false;
  previousOption: string;
  isOpened = false;
  queryText: string = '';

  constructor() {}
  ngOnChanges(changes: SimpleChanges): void {
    this.previousOption = changes?.ngModelValue?.currentValue;
  }

  ngOnInit(): void {
    // Default search function if none is provided
    this.searchFn =
      this.searchFn || ((term: string, item: any) => item?.name?.toLowerCase().startsWith(term.toLowerCase()));
    // Sort items alphabetically if sortByAlphabet is true
    if (this.sortByAlphabet) {
      this.items = this.sortItems(this.items, this.sortByField);
    }
    // showSearchInOptPanel if received "true" as input or if searchable and items length is more than 5 else false
    this.showSearchInOptPanel =
      this.showSearchInOptPanel === true
        ? this.showSearchInOptPanel
        : this.searchable && this.items && this.items.length >= 5;
  }

  testSearch(term: string, item: any) {
    const searchString = typeof item === 'object' ? item.name.toString().toLowerCase() : item.toString().toLowerCase();
    return searchString.startsWith(term.toLowerCase());
  }

  isSameOptionSelected(data): void {
    if (data?.toLowerCase() === this.previousOption?.toLowerCase()) {
      this.sameOptionSelected.emit(data);
    }
  }

  private sortWithAllFirst = (a, b) => {
    const getPriority = (item: { name: string }): [number, string] => {
      const name = item.name.trim();

      if (name === FiltersPopUpTagsEnum.ALL_RISK_GROUPS) {
        return [0, ''];
      }
      if (name === FiltersPopUpTagsEnum.ALL_RISKS) {
        return [1, ''];
      }
      if (name === FiltersPopUpTagsEnum.ALL) {
        return [2, ''];
      }
      return [3, name.toLowerCase()];
    };

    const [priorityA, nameA] = getPriority(a);
    const [priorityB, nameB] = getPriority(b);

    if (priorityA !== priorityB) {
      return priorityA - priorityB;
    }

    return nameA.localeCompare(nameB);
  };

  sortItems(array: any, field: string = ''): any[] {
    array.sort(this.sortWithAllFirst);
    return array;
  }

  openSelect(): void {
    this.selectInput.open();
    // Below condition is only for risk register component. When editing the status of the risk.
    // Need to show the change text in main field.
    if (this.fromRiskRegister) {
      this.isOpened = !this.isOpened;
      this.ngModelValue = 'Change';
    }
    this.selectOpened.emit(this.selectInput);
  }
  changeValue(item) {
    if (this.fromRiskRegister) {
      this.isOpened = false;
    }
    this.ngModelValueChange.emit(item);
    return item.selected;
  }

  closeSelect(): void {
    this.selectClosed.emit(true);
  }

  inputEvent(event: any) {
    return this.selectInput.filter(event.target.value);
  }
}
